const timeline = [
  {
    year: '2010',
    title: 'Основание компании',
    text: 'Открытие первой аптеки Горздрав в Москве. Небольшая команда энтузиастов с большой идеей — сделать качественные лекарства доступными каждому.',
    color: '#ff2d78',
    icon: 'ri-flag-line',
  },
  {
    year: '2013',
    title: 'Региональная экспансия',
    text: 'Выход в Санкт-Петербург и Московскую область. Сеть насчитывает уже 50 аптек. Запуск собственной логистической инфраструктуры.',
    color: '#00f5ff',
    icon: 'ri-map-2-line',
  },
  {
    year: '2016',
    title: 'Запуск интернет-аптеки',
    text: 'Открытие онлайн-платформы gorzdrav.org. Первыми в России внедрили систему бронирования лекарств с самовывозом из аптеки в течение 1 часа.',
    color: '#39ff14',
    icon: 'ri-global-line',
  },
  {
    year: '2018',
    title: '500 аптек',
    text: 'Достигнут рубеж в 500 аптек. Запуск мобильного приложения с более чем 1 млн загрузок в первый год. Внедрение бонусной программы лояльности.',
    color: '#f0ff00',
    icon: 'ri-award-line',
  },
  {
    year: '2021',
    title: 'Цифровая трансформация',
    text: 'Полный переход на цифровые рецепты. Интеграция с ЕГИСЗ. Запуск экспресс-доставки за 15 минут в Москве и Санкт-Петербурге.',
    color: '#ff6b00',
    icon: 'ri-smartphone-line',
  },
  {
    year: '2024',
    title: 'Более 1 000 аптек',
    text: 'Горздрав входит в топ-3 аптечных сетей России. Более 2 миллионов клиентов ежемесячно. Расширение в 40+ регионов страны.',
    color: '#ff2d78',
    icon: 'ri-rocket-line',
  },
];

const AboutHistory = () => (
  <section id="history" className="px-6 lg:px-12 pb-24 relative">
    <div className="max-w-7xl mx-auto">
      {/* Section header */}
      <div className="mb-14">
        <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/60 mb-2">НАША ИСТОРИЯ</p>
        <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white">
          ПУТЬ К УСПЕХУ
        </h2>
        <div className="mt-3 w-16 h-0.5" style={{ background: 'linear-gradient(90deg, #ff2d78, transparent)' }} />
      </div>

      {/* Timeline */}
      <div className="relative">
        {/* Vertical line */}
        <div
          className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px hidden sm:block"
          style={{ background: 'linear-gradient(to bottom, #ff2d78, #00f5ff, #39ff14, #f0ff00, #ff6b00, #ff2d78)', opacity: 0.3 }}
        />

        <div className="space-y-10">
          {timeline.map((item, idx) => {
            const isLeft = idx % 2 === 0;
            return (
              <div
                key={item.year}
                className={`relative flex flex-col sm:flex-row items-start sm:items-center gap-6 ${isLeft ? 'sm:flex-row' : 'sm:flex-row-reverse'}`}
              >
                {/* Card */}
                <div className={`w-full sm:w-[calc(50%-2.5rem)] card-cyber rounded-2xl p-6 group transition-all duration-300 ${isLeft ? 'sm:text-right' : 'sm:text-left'}`} style={{ borderColor: `${item.color}25` }}>
                  <div className={`flex items-center gap-3 mb-3 ${isLeft ? 'sm:flex-row-reverse' : ''}`}>
                    <div
                      className="w-9 h-9 flex items-center justify-center rounded-xl shrink-0"
                      style={{ background: `${item.color}15`, border: `1px solid ${item.color}40` }}
                    >
                      <i className={`${item.icon} text-base`} style={{ color: item.color }} />
                    </div>
                    <span
                      className="font-orbitron font-black text-2xl"
                      style={{ color: item.color, textShadow: `0 0 12px ${item.color}60` }}
                    >
                      {item.year}
                    </span>
                  </div>
                  <h3 className="font-orbitron font-bold text-sm text-white mb-2">{item.title}</h3>
                  <p className="font-mono text-xs text-white/40 leading-relaxed">{item.text}</p>
                  <div
                    className="absolute bottom-0 left-0 right-0 h-0.5 rounded-b-2xl opacity-0 group-hover:opacity-100 transition-opacity"
                    style={{ background: `linear-gradient(90deg, transparent, ${item.color}, transparent)` }}
                  />
                </div>

                {/* Center dot */}
                <div className="hidden sm:flex w-5 h-5 items-center justify-center shrink-0 relative z-10">
                  <div
                    className="w-3 h-3 rounded-full"
                    style={{ background: item.color, boxShadow: `0 0 12px ${item.color}` }}
                  />
                </div>

                {/* Spacer */}
                <div className="hidden sm:block w-[calc(50%-2.5rem)]" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default AboutHistory;
